import { gql } from "@apollo/client";

export default gql`
  mutation batchAssessmentDeliveryActionMutation(
    $organizationId: Int!
    $complianceProgramId: Int!
    $targetIds: [Int!]!
    $action: BatchCalibrationAction!
  ) {
    batchAssessmentDeliveryAction(
      organizationId: $organizationId
      complianceProgramId: $complianceProgramId
      targetIds: $targetIds
      action: $action
    ) {
      assessmentDeliveries {
        id
        state
        canUpdate {
          permission
        }
        canRead {
          permission
        }
      }
      reportRows {
        edges {
          node {
            id
            calibrationStatus
          }
        }
      }
    }
  }
`;
